<ara-side-nav
  #navbar
  class="inside-topnav"
  [routesFlag]="routesFlag"
  [reportRoutes]="reportRoutes"
></ara-side-nav>
<form [formGroup]="PTWForm" #ptwForm="ngForm">
  <div class="page-content-wrapper">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mobile-view">
      <ol class="breadcrumb bc-3">
        <li>
          <a [routerLink]="'/home'">Home</a>
        </li>
        <li>
          <a>Permit To Work</a>
        </li>
      </ol>
      <div class="inner-wrapper">
        <div class="sub-wrapper" [ngClass]="permitClassName">
          <h3 class="page-title obs-card-title" style="text-align: center">
            <span class="page-sub-title">
              <ng-container *ngIf="isUpdate"
                >Permit : {{ PTWForm.get("PTWNumber").value }}
              </ng-container>
              <ng-container *ngIf="permitId === 0"
                >Apply for Permit
              </ng-container>
            </span>
            <button
              *ngIf="isUpdate"
              (click)="isNext ? onNextClick() : $event.preventDefault()"
              [ngClass]="isNext ? 'cursor-pointer' : 'disabled'"
              class="pull-right btn btn-primary primary-btn"
            >
              <i class="fa fa-angle-right"></i>
            </button>
            <button
              *ngIf="isUpdate"
              (click)="isPrevious ? onPreviousClick() : $event.preventDefault()"
              [ngClass]="isPrevious ? 'cursor-pointer' : 'disabled'"
              class="pull-right btn btn-primary primary-btn"
            >
              <i class="fa fa-angle-left"></i>
            </button>
          </h3>
          <div class="section-wrapper right">
            <span class="mandatory-info">
              Fields marked with
              <span class="mandatory">*</span> are mandatory
            </span>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
            <div class="sub-section-wrapper">
              <span class="section-sub-title"
                >Unit <span class="mandatory">*</span
                ><i
                  class="fa fa-info-circle"
                  pTooltip="Unit are enabled for interaction based on permission of User"
                ></i
              ></span>
              <p-tree
                [value]="unitTree"
                selectionMode="single"
                (onNodeSelect)="nodeSelected($event)"
                [(selection)]="selectedUnit"
              ></p-tree>
              <span
                class="error-msg-colour"
                *ngIf="!selectedUnit && ptwForm.submitted"
                >Please Select Unit</span
              >
            </div>
            <div class="sub-section-wrapper" [hidden]="isEmployeeUnit">
              <span class="section-sub-title"
                >Contract Number:<span class="mandatory">*</span></span
              >
              <p-dropdown
                [options]="contracts"
                formControlName="Contract"
                placeholder="Select"
                [style]="{ width: '100%' }"
                [(ngModel)]="selectedContract"
                (onChange)="checkHolder($event)"
              >
              </p-dropdown>
              <span
                class="error-msg-colour"
                *ngIf="
                  ptwForm.submitted &&
                  PTWForm.get('Contract').hasError('required')
                "
                >Please select Contract
              </span>
              <span class="error-msg-colour" *ngIf="!isHasContractDetails"
                >Contract Holder is not available for this contract. Please
                contact admin to update these details.
              </span>
            </div>
            <div class="sub-section-wrapper">
              <span class="section-sub-title">
                Activity : <span class="mandatory">*</span>
              </span>
              <p-dropdown
                [options]="activityList"
                placeholder="Select"
                formControlName="SelectedActivity"
                [style]="{ width: '100%' }"
                (onChange)="getSubActivities($event)"
              >
              </p-dropdown>
              <span
                class="error-msg-colour"
                *ngIf="
                  ptwForm.submitted &&
                  PTWForm.get('SelectedActivity').hasError('required')
                "
                >Please Select Activity</span
              >
            </div>
            <div class="sub-section-wrapper">
              <span class="section-sub-title">
                Sub-Activity : <span class="mandatory">*</span>
              </span>
              <p-dropdown
                [options]="subActivityList"
                (onChange)="decidePermitType()"
                placeholder="Select"
                formControlName="SelectedSubActivity"
                [style]="{ width: '100%' }"
              >
              </p-dropdown>
              <span
                class="error-msg-colour"
                *ngIf="
                  ptwForm.submitted &&
                  PTWForm.get('SelectedSubActivity').hasError('required')
                "
                >Please Select Sub-Activity</span
              >
            </div>
            <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20">
                Process Facility :
              </span>
              <label class="radio-inline">
                <input
                  type="radio"
                  value="true"
                  name="IsProcessFacility"
                  formControlName="IsProcessFacility"
                />Yes
              </label>
              <label class="radio-inline">
                <input
                  type="radio"
                  value="false"
                  name="IsProcessFacility"
                  formControlName="IsProcessFacility"
                />No
              </label>
              <span
                class="error-msg-colour"
                *ngIf="
                  ptwForm.submitted &&
                  PTWForm.get('IsProcessFacility').hasError('required')
                "
                >Please Select Yes or No</span
              >
            </div>
            <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20">
                Hydrocarbon Area :
              </span>
              <label class="radio-inline">
                <input
                  type="radio"
                  value="true"
                  name="IsHydrocarbonArea"
                  formControlName="IsHydrocarbonArea"
                />Yes
              </label>
              <label class="radio-inline">
                <input
                  type="radio"
                  value="false"
                  name="IsHydrocarbonArea"
                  formControlName="IsHydrocarbonArea"
                />No
              </label>
              <span
                class="error-msg-colour"
                *ngIf="
                  ptwForm.submitted &&
                  PTWForm.get('IsHydrocarbonArea').hasError('required')
                "
                >Please Select Yes or No</span
              >
            </div>
            <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20">
                Hazardous Area :
              </span>
              <label class="radio-inline">
                <input
                  type="radio"
                  value="true"
                  name="IsHazardousArea"
                  formControlName="IsHazardousArea"
                />Yes
              </label>
              <label class="radio-inline">
                <input
                  type="radio"
                  value="false"
                  name="IsHazardousArea"
                  formControlName="IsHazardousArea"
                />No
              </label>
              <span
                class="error-msg-colour"
                *ngIf="
                  ptwForm.submitted &&
                  PTWForm.get('IsHazardousArea').hasError('required')
                "
                >Please Select Yes or No</span
              >
            </div>
            <div
              *ngIf="PTWForm.get('IsHazardousArea').value == 'true'"
              class="sub-section-wrapper"
            >
              <span class="section-sub-title margin-right-20">
                Hazardous Area Classification:
              </span>
              <span class="mandatory">*</span>
              <p-multiSelect
                [options]="hazardousZones"
                placeholder="Select"
                formControlName="HazardousZones"
                [style]="{ width: '100%' }"
              >
              </p-multiSelect>
              <span
                class="error-msg-colour"
                *ngIf="
                  ptwForm.submitted &&
                  PTWForm.get('HazardousZones').hasError('required')
                "
                >Please Select Hazardous Area</span
              >
            </div>
            <div class="sub-section-wrapper">
              <span class="section-sub-title">
                Gas Test required before starting work each day and after being
                away for over an hour :
              </span>
              <label class="radio-inline">
                <input
                  type="radio"
                  value="true"
                  name="IsGasTestBeforeAfterDay"
                  formControlName="IsGasTestBeforeAfterDay"
                />Yes
              </label>
              <label class="radio-inline">
                <input
                  type="radio"
                  value="false"
                  name="IsGasTestBeforeAfterDay"
                  formControlName="IsGasTestBeforeAfterDay"
                />No
              </label>
              <span
                class="error-msg-colour"
                *ngIf="
                  ptwForm.submitted &&
                  PTWForm.get('IsGasTestBeforeAfterDay').hasError('required')
                "
                >Please Select Yes or No</span
              >
            </div>
            <div class="sub-section-wrapper">
              <span class="section-sub-title">
                Gas Test required every 2 hours where significant quantities of
                gas may be present :
              </span>
              <label class="radio-inline">
                <input
                  type="radio"
                  value="true"
                  name="IsGasTestEveryTwoHour"
                  formControlName="IsGasTestEveryTwoHour"
                />Yes
              </label>
              <label class="radio-inline">
                <input
                  type="radio"
                  value="false"
                  name="IsGasTestEveryTwoHour"
                  formControlName="IsGasTestEveryTwoHour"
                />No
              </label>
              <span
                class="error-msg-colour"
                *ngIf="
                  ptwForm.submitted &&
                  PTWForm.get('IsGasTestEveryTwoHour').hasError('required')
                "
                >Please Select Yes or No</span
              >
            </div>
            <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20">
                Continues Gas Monitoring Required :
              </span>
              <label class="radio-inline">
                <input
                  type="radio"
                  value="true"
                  name="IsContinueGasMonitoring"
                  formControlName="IsContinueGasMonitoring"
                />Yes
              </label>
              <label class="radio-inline">
                <input
                  type="radio"
                  value="false"
                  name="IsContinueGasMonitoring"
                  formControlName="IsContinueGasMonitoring"
                />No
              </label>
              <span
                class="error-msg-colour"
                *ngIf="
                  ptwForm.submitted &&
                  PTWForm.get('IsContinueGasMonitoring').hasError('required')
                "
                >Please Select Yes or No</span
              >
            </div>
            <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20">
                Safety Equipements Required :
              </span>
              <label class="radio-inline">
                <input
                  type="radio"
                  value="true"
                  name="IsSafetyEquipment"
                  formControlName="IsSafetyEquipment"
                />Yes
              </label>
              <label class="radio-inline">
                <input
                  type="radio"
                  value="false"
                  name="IsSafetyEquipment"
                  formControlName="IsSafetyEquipment"
                />No
              </label>
              <span
                class="error-msg-colour"
                *ngIf="
                  ptwForm.submitted &&
                  PTWForm.get('IsSafetyEquipment').hasError('required')
                "
                >Please Select Yes or No</span
              >
            </div>
            <div
              *ngIf="PTWForm.get('AdditionalComments').value"
              class="sub-section-wrapper"
            >
              <div>
                <span class="section-sub-title"> Additional Comments : </span>
                {{ PTWForm.get("AdditionalComments").value }}
              </div>
            </div>
            <div class="sub-section-wrapper">
              <span class="section-sub-title"> Permit Type : </span>
              <span>{{ PTWForm.get("PermitType").value }}</span>
            </div>
            <div class="sub-section-wrapper">
              <span class="section-sub-title">
                Permit Number : {{ PTWForm.get("PTWNumber").value }}
              </span>
            </div>
            <div class="sub-section-wrapper">
              <span class="section-title"> Application and Description </span>
              <span class="section-sub-title"
                >Location:<span class="mandatory">*</span></span
              >
              <p-dropdown
                [options]="locations"
                placeholder="Select"
                formControlName="unitLocation"
                (onChange)="saveLocation()"
                [disabled]="
                  isUpdate &&
                  permitStatus !== PermitStatus.Draft &&
                  isInactiveLocation &&
                  !independentPermissions.APP_Admin &&
                  !independentPermissions.HSE_Admin &&
                  !independentPermissions.SUPER_Admin
                "
                [style]="{ width: '100%' }"
              >
              </p-dropdown>
              <span
                class="error-msg-colour"
                *ngIf="
                  ptwForm.submitted &&
                  PTWForm.get('unitLocation').hasError('required')
                "
                >Please Select Location</span
              >

              <span class="error-msg-colour" *ngIf="isInactiveLocation"
                >This Location is In Active.</span
              >
            </div>
            <ara-exact-location
              [Location]="PTWForm.get('ExactLocation')?.value"
              [IsRequired]="true"
              (Output)="setExactLocation($event)"
            >
            </ara-exact-location>
            <span
              class="error-msg-colour"
              *ngIf="
                ptwForm.submitted &&
                PTWForm.get('ExactLocation').hasError('required')
              "
              >Please Select Exact Location</span
            >
            <div class="sub-section-wrapper">
              <span class="section-sub-title">
                Worksite : <span class="mandatory">*</span></span
              >
              <div class="clearfix"></div>
              <input
                type="text"
                maxlength="50"
                value=""
                class="form-control margin-top-8"
                id="worksite"
                placeholder="Select"
                formControlName="Worksite"
              />
              <span
                class="error-msg-colour"
                *ngIf="
                  ptwForm.submitted &&
                  PTWForm.get('Worksite').hasError('required')
                "
                >Please Enter Work Site</span
              >
            </div>
            <div class="sub-section-wrapper">
              <span class="section-sub-title">
                Work Description : <span class="mandatory">*</span></span
              >
              <div class="clearfix"></div>
              <textarea
                #textArea
                class="form-control"
                rows="4"
                cols="30"
                [maxLength]="1000"
                formControlName="WorkDescription"
              ></textarea>
              <span
                class="error-msg-colour"
                *ngIf="
                  ptwForm.submitted &&
                  PTWForm.get('WorkDescription').hasError('required')
                "
                >Please Write Work Description</span
              >
            </div>
            <div class="sub-section-wrapper">
              <span class="section-sub-title">
                Job Quality Health Safety Environment Plan :<span
                  class="mandatory"
                  >*</span
                ></span
              >
              <ara-file-upload
                (change)="invalidEnvironmentPlan = false"
                [inputFiles]="SafetyEnvironmentPlanFiles"
                [multiple]="true"
                (onInputFilesUpdatedData)="
                  onInputFilesUpdated($event, 'SafetyEnvironmentPlan', 0)
                "
                [disabled]="false"
              >
              </ara-file-upload>
              <ara-files-previewer
                *ngIf="isUpdate"
                [files]="SafetyEnvironmentPlanFiles"
              ></ara-files-previewer>
              <span
                class="error-msg-colour"
                *ngIf="
                  ptwForm.submitted && SafetyEnvironmentPlanFiles.length < 1
                "
                >Please Upload File</span
              >
            </div>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
            <div *ngIf="isPermitJob">
              <div class="sub-section-wrapper">
                <span class="section-sub-title margin-right-20">
                  NORM Contaminated Area :
                </span>
                <label class="radio-inline">
                  <input
                    type="radio"
                    value="true"
                    name="IsNORMContaminatedArea"
                    formControlName="IsNORMContaminatedArea"
                  />Yes
                </label>
                <label class="radio-inline">
                  <input
                    type="radio"
                    value="false"
                    name="IsNORMContaminatedArea"
                    formControlName="IsNORMContaminatedArea"
                  />No
                </label>
                <span
                  class="error-msg-colour"
                  *ngIf="
                    ptwForm.submitted &&
                    PTWForm.get('IsNORMContaminatedArea').hasError('required')
                  "
                  >Please Select Yes or No</span
                >
              </div>
              <div class="sub-section-wrapper">
                <span class="section-sub-title margin-right-20">
                  Mercury Potential :
                </span>
                <label class="radio-inline">
                  <input
                    type="radio"
                    value="true"
                    name="IsMercuryPotential"
                    formControlName="IsMercuryPotential"
                  />Yes
                </label>
                <label class="radio-inline">
                  <input
                    type="radio"
                    value="false"
                    name="IsMercuryPotential"
                    formControlName="IsMercuryPotential"
                  />No
                </label>
                <span
                  class="error-msg-colour"
                  *ngIf="
                    ptwForm.submitted &&
                    PTWForm.get('IsMercuryPotential').hasError('required') &&
                    ptwForm.submitted
                  "
                  >Please Select Yes or No</span
                >
              </div>
              <div class="sub-section-wrapper">
                <span class="section-sub-title margin-right-20">
                  H2S Facility Classification :
                </span>
                <label class="radio-inline">
                  <input
                    type="radio"
                    value="High"
                    name="H2SFacilityClassification"
                    id="High"
                    formControlName="H2SFacilityClassification"
                  />High
                </label>
                <label class="radio-inline">
                  <input
                    type="radio"
                    value="Low"
                    name="H2SFacilityClassification"
                    id="Low"
                    formControlName="H2SFacilityClassification"
                  />Low
                </label>
                <label class="radio-inline">
                  <input
                    type="radio"
                    value="Normal"
                    name="H2SFacilityClassification"
                    id="Normal"
                    formControlName="H2SFacilityClassification"
                  />Normal
                </label>
                <span
                  class="error-msg-colour"
                  *ngIf="
                    ptwForm.submitted &&
                    PTWForm.get('H2SFacilityClassification').hasError(
                      'required'
                    )
                  "
                  >Please Select High Or Low Or Non</span
                >
              </div>
              <div class="sub-section-wrapper">
                <span class="section-sub-title margin-right-20">
                  Expected Max PPM : <span class="mandatory">*</span></span
                >
                <div class="clearfix"></div>
                <input
                  type="text"
                  maxlength="50"
                  class="form-control margin-top-8"
                  id="expMaxPPM"
                  placeholder="Select"
                  formControlName="ExpectedMaxPPM"
                />
                <span
                  class="error-msg-colour"
                  *ngIf="
                    PTWForm.get('ExpectedMaxPPM').hasError('required') &&
                    ptwForm.submitted
                  "
                  >Please Enter Expected PPM</span
                >
                <span
                  class="error-msg-colour"
                  *ngIf="
                    PTWForm.get('ExpectedMaxPPM').hasError('pattern') &&
                    ptwForm.submitted
                  "
                  >Please Enter Only Numbers values</span
                >
              </div>
              <div class="sub-section-wrapper">
                <span class="section-sub-title"> Associated PTW No :</span>
                <div class="clearfix"></div>
                <input
                  type="text"
                  maxlength="50"
                  value=""
                  class="form-control margin-top-8"
                  id="associatedPTW"
                  placeholder="Select"
                  formControlName="AssociatedPTWno"
                />
                <span
                  class="error-msg-colour"
                  *ngIf="
                    ptwForm.submitted &&
                    PTWForm.get('AssociatedPTWno').hasError('required')
                  "
                  >Please Enter Associated PTW Number</span
                >
              </div>
              <div class="sub-section-wrapper">
                <span class="section-sub-title"> Work Order / EWP No :</span>
                <div class="clearfix"></div>
                <input
                  type="text"
                  maxlength="50"
                  value=""
                  class="form-control margin-top-8"
                  id="workOrder"
                  placeholder="Select"
                  formControlName="EWPno"
                />
                <span
                  class="error-msg-colour"
                  *ngIf="
                    ptwForm.submitted &&
                    PTWForm.get('EWPno').hasError('required')
                  "
                  >Please Enter Work order / EWP No</span
                >
              </div>
            </div>
            <div>
              <span class="section-title"> Gas Testing Requirements </span>
              <div class="sub-section-wrapper">
                <span class="section-sub-title"> Gas to be Tested for : </span>
                <div class="clearfix"></div>
                <label>
                  <input
                    type="checkbox"
                    formControlName="GasTestedForHC"
                    (click)="
                      GasSelectedCheck($event.target.checked, 'GasTestedForHC')
                    "
                  />
                  &nbsp; Hydrocarbon
                </label>
                <label>
                  <input
                    type="checkbox"
                    formControlName="GasTestedForH2S"
                    (click)="
                      GasSelectedCheck($event.target.checked, 'GasTestedForH2S')
                    "
                  />
                  &nbsp; H2S</label
                >
                <label>
                  <input
                    type="checkbox"
                    formControlName="GasTestedForO2"
                    (click)="
                      GasSelectedCheck($event.target.checked, 'GasTestedForO2')
                    "
                  />
                  &nbsp; Oxygen</label
                >
                <label>
                  <input
                    type="checkbox"
                    formControlName="GasTestedForOther"
                    (click)="
                      GasSelectedCheck(
                        $event.target.checked,
                        'GasTestedForOther'
                      )
                    "
                  />
                  &nbsp; Other</label
                >
                <div class="clearfix"></div>
                <div *ngIf="PTWForm.value.GasTestedForOther">
                  <span class="section-sub-title"> Specify : </span>
                  <input
                    type="text"
                    maxlength="50"
                    value=""
                    class="form-control"
                    id="gasSpecify"
                    placeholder="Select"
                    formControlName="GasTestSpecify"
                  />
                  <span
                    class="error-msg-colour"
                    *ngIf="
                      ptwForm.submitted &&
                      PTWForm.get('GasTestSpecify').hasError('required')
                    "
                    >Please Specify Gas Names</span
                  >
                </div>
              </div>
              <div class="sub-section-wrapper">
                <span class="section-sub-title">
                  Gas test to be repeated at interval of (In Hours ):
                  <span
                    class="mandatory"
                    *ngIf="PTWForm.get('GasTestInterval').invalid"
                    >*</span
                  ></span
                >
                <input
                  type="number"
                  appNumberOnly
                  (change)="GasSelectedCheck('', '')"
                  maxlength="50"
                  size="4"
                  class="form-control margin-top-8"
                  formControlName="GasTestInterval"
                />
                <span
                  class="error-msg-colour"
                  *ngIf="PTWForm.get('GasTestInterval').invalid"
                  >Please Specify Gas Testing Interval</span
                >
              </div>
            </div>
            <div *ngIf="isPermitJob">
              <span class="section-title">
                Worksite Examination Required by Area Authority
              </span>
              <div class="sub-section-wrapper">
                <span class="section-sub-title margin-right-20">
                  Worksite Examination First Day :
                </span>
                <label class="radio-inline">
                  <input
                    type="radio"
                    value="true"
                    name="IsWorkExaminationFirstDay"
                    formControlName="IsWorkExaminationFirstDay"
                  />Yes
                </label>
                <label class="radio-inline">
                  <input
                    type="radio"
                    value="false"
                    name="IsWorkExaminationFirstDay"
                    formControlName="IsWorkExaminationFirstDay"
                  />No
                </label>
                <span
                  class="error-msg-colour"
                  *ngIf="
                    ptwForm.submitted &&
                    PTWForm.get('IsWorkExaminationFirstDay').hasError(
                      'required'
                    )
                  "
                  >Please Select Yes Or No</span
                >
              </div>
              <div class="sub-section-wrapper">
                <span class="section-sub-title margin-right-20">
                  By Validator Everyday :
                </span>
                <label class="radio-inline">
                  <input
                    type="radio"
                    value="true"
                    name="IsValidatorEveryday"
                    formControlName="IsValidatorEveryday"
                  />Yes
                </label>
                <label class="radio-inline">
                  <input
                    type="radio"
                    value="false"
                    name="IsValidatorEveryday"
                    formControlName="IsValidatorEveryday"
                  />No
                </label>
                <span
                  class="error-msg-colour"
                  *ngIf="
                    ptwForm.submitted &&
                    PTWForm.get('IsValidatorEveryday').hasError('required')
                  "
                  >Please Select Yes Or No</span
                >
              </div>
            </div>
            <div *ngIf="isPermitJob">
              <span class="section-title"> Vehicle Access </span>
              <div class="sub-section-wrapper">
                <span class="section-sub-title margin-right-20">
                  Vehicle Entry Required :
                  <span class="mandatory">*</span></span
                >
                <label class="radio-inline">
                  <input
                    type="radio"
                    (change)="vehicleSelectedCheck()"
                    value="true"
                    name="IsVehicleRequired"
                    formControlName="IsVehicleRequired"
                  />Yes
                </label>
                <label class="radio-inline">
                  <input
                    #Vehicle
                    type="radio"
                    (change)="vehicleSelectedCheck()"
                    value="false"
                    name="IsVehicleRequired"
                    formControlName="IsVehicleRequired"
                  />No
                </label>
                <span
                  class="error-msg-colour"
                  *ngIf="
                    ptwForm.submitted &&
                    PTWForm.get('IsVehicleRequired').hasError('required')
                  "
                  >Please Select Yes Or No</span
                >
              </div>
              <div *ngIf="PTWForm.get('IsVehicleRequired').value == 'true'">
                <div class="sub-section-wrapper">
                  <span class="section-sub-title">
                    Vehicle Access Route Plan Prepared and Approved :
                  </span>
                  <div class="clearfix"></div>
                  <label class="radio-inline">
                    <input
                      type="radio"
                      value="true"
                      name="IsVehicleApproved"
                      formControlName="IsVehicleApproved"
                    />Yes
                  </label>
                  <label class="radio-inline">
                    <input
                      type="radio"
                      value="false"
                      name="IsVehicleApproved"
                      formControlName="IsVehicleApproved"
                    />No
                  </label>
                  <span
                    class="error-msg-colour"
                    *ngIf="
                      ptwForm.submitted &&
                      PTWForm.get('IsVehicleApproved').hasError('required')
                    "
                    >Please Select Yes Or No</span
                  >
                </div>
                <div class="sub-section-wrapper">
                  <span class="section-sub-title">
                    Vehicle Entry Checklist : <span class="mandatory">*</span>
                  </span>
                  <ara-file-upload
                    [inputFiles]="VehicleEntryChecklistFiles"
                    (change)="invalidVehicleEntry = false"
                    [multiple]="true"
                    (onInputFilesUpdatedData)="
                      onInputFilesUpdated($event, 'VehicleEntryChecklist', 0)
                    "
                    [disabled]="false"
                  >
                  </ara-file-upload>
                  <ara-files-previewer
                    *ngIf="isUpdate"
                    [files]="VehicleEntryChecklistFiles"
                  ></ara-files-previewer>
                  <span class="error-msg-colour" *ngIf="invalidVehicleEntry"
                    >Please Upload File</span
                  >
                </div>

                <div class="sub-section-wrapper">
                  <span class="section-sub-title">
                    Permission is given to the Permit Holder to take the
                    following vehicle(s) of the following type(s) to the work
                    site/location:
                  </span>
                </div>
                <div class="sub-section-wrapper">
                  <span class="section-sub-title">
                    Vehicle Type : <span class="mandatory">*</span>
                    <input
                      type="text"
                      maxlength="50"
                      value=""
                      class="form-control margin-top-8"
                      id="vehicleType"
                      placeholder="Select"
                      formControlName="VehicleType"
                    />
                  </span>
                  <span
                    class="error-msg-colour"
                    *ngIf="
                      ptwForm.submitted &&
                      PTWForm.get('VehicleType').hasError('required')
                    "
                    >Please Specify Vehicle Type</span
                  >
                </div>
                <div class="sub-section-wrapper">
                  <span class="section-sub-title">
                    Location : <span class="mandatory">*</span>
                    <input
                      type="text"
                      maxlength="50"
                      value=""
                      class="form-control margin-top-8"
                      id="vehicleLocation"
                      placeholder="Select"
                      formControlName="Location"
                    />
                  </span>
                  <span
                    class="error-msg-colour"
                    *ngIf="
                      ptwForm.submitted &&
                      PTWForm.get('Location').hasError('required')
                    "
                    >Please Specify Location</span
                  >
                </div>
              </div>
              <p-messages [(value)]="vehicleNote"></p-messages>
              <div
                *ngIf="
                  (isUpdate &&
                    isGasTestVisible &&
                    (permissions.PTW_Authorised_Gas_Tester_Unit ||
                      permissions.PTW_Authorised_Gas_Tester ||
                      permissions.PTW_Admin ||
                      permissions.PTW_Admin_Unit ||
                      isOncomingUserAndApplicant)) ||
                  gasTestRecords.length > 0
                "
              >
                <span class="section-title">Gas Test Records</span>
                <ara-ptw-gas-test-record-table
                  (onGasRecordUpdate)="onGasRecordUpdate($event)"
                  [PermitId]="permitId"
                  [LastValueOfRecord]="gasTestLastRecordId"
                  [Permissions]="permissions"
                  [inputRecords]="gasTestRecords"
                  [initialTextForTextArea]="gasRecordInitialText"
                  [addRecords]="
                    ((permissions.PTW_Authorised_Gas_Tester_Unit ||
                      permissions.PTW_Authorised_Gas_Tester ||
                      isOncomingUserAndApplicant) &&
                      !disablePTW) ||
                    permissions.PTW_Admin ||
                    permissions.PTW_Admin_Unit
                  "
                >
                </ara-ptw-gas-test-record-table>
                <div
                  *ngIf="
                    ((permissions.PTW_Authorised_Gas_Tester_Unit ||
                      permissions.PTW_Authorised_Gas_Tester ||
                      isOncomingUserAndApplicant) &&
                      !disablePTW) ||
                    permissions.PTW_Admin ||
                    permissions.PTW_Admin_Unit
                  "
                >
                  <input
                    type="button"
                    class="btn btn-primary button-update-records"
                    formControlName="btnUpdateGasTestRecord"
                    (click)="uploadGasTestRecords()"
                    value="Update Records"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
            <div *ngIf="isPermitJob" id="PlannerPlan">
              <span class="section-sub-title">
                Planner Agrees in Frozen Plan :<span class="mandatory">*</span>

                <label class="radio-inline">
                  <input type="checkbox" formControlName="IsAgreeFrozenPlan"
                /></label>
              </span>
              <span
                class="error-msg-colour"
                *ngIf="
                  ptwForm.submitted && !PTWForm.get('IsAgreeFrozenPlan').value
                "
                >Please Tick Frozen Plan</span
              >
            </div>
            <div
              *ngIf="
                (PTWForm.get('IsAgreeFrozenPlan').value && isPermitJob) ||
                !isPermitJob
              "
            >
              <div *ngIf="isPermitJob">
                <p-messages [(value)]="AgreeFrozenPlan"></p-messages>
              </div>
              <div>
                <span class="section-title"> Application By Applicant </span>
              </div>
              <div class="sub-section-wrapper">
                <span class="section-sub-title">
                  Name : {{ applicantName }}
                </span>
              </div>
              <div class="sub-section-wrapper">
                <span class="section-sub-title">
                  Designation : {{ applicantDesignation }}
                </span>
              </div>
              <div class="sub-section-wrapper">
                <span class="section-sub-title">
                  Telephone No : {{ applicantTelNo }}
                </span>
              </div>
              <div class="sub-section-wrapper">
                <span class="section-sub-title">
                  Contractor Name : <span class="mandatory">*</span></span
                >
                <p-autoComplete
                  formControlName="ContractorName"
                  [suggestions]="userResults"
                  appendTo="body"
                  (completeMethod)="getContractorsOnSearch($event)"
                  (onSelect)="selectContractor($event)"
                  (onChange)="selectContractor($event)"
                  placeholder="Contractor Name"
                  field="FullName"
                  [minLength]="1"
                  [forceSelection]="true"
                >
                  <ng-template let-employee pTemplate="item">
                    <span [title]="employee.Email">{{
                      employee.FullName
                    }}</span>
                  </ng-template>
                </p-autoComplete>
                <span
                  class="error-msg-colour"
                  *ngIf="
                    ptwForm.submitted &&
                    PTWForm.get('ContractorName').hasError('required')
                  "
                  >Please Select Contractor</span
                >
              </div>
              <div *ngIf="isPermitJob" class="sub-section-wrapper">
                <span class="section-sub-title" style="width: 100%">
                  Names of Oncoming Permit Holder :<span class="mandatory"
                    >*</span
                  >
                  <p-multiSelect
                    [options]="allUsersData"
                    placeholder="Select"
                    formControlName="oncomingHolders"
                    [style]="{ width: '100%' }"
                  >
                  </p-multiSelect>
                </span>
                <span
                  class="error-msg-colour"
                  *ngIf="
                    ptwForm.submitted &&
                    PTWForm.get('oncomingHolders').hasError('required')
                  "
                  >Please Select Oncoming Permit Holder</span
                >
              </div>
              <div class="sub-section-wrapper">
                <span class="section-sub-title">
                  Date : {{ permitDate | dateTimeFormat : "DD/MM/YYYY" }}
                </span>
              </div>
              <div class="sub-section-wrapper">
                <div class="section-sub-title">
                  Duration Requested : <span class="mandatory">*</span>
                </div>
                <div class="clearfix calender-width"></div>
                <span class="section-sub-title"> From </span>
                <div class="p-calendar calender-width">
                  <p-calendar
                    hourFormat="12"
                    (onSelect)="onDurationFromDateChange()"
                    [showIcon]="true"
                    dateFormat="dd/mm/yy"
                    [showTime]="false"
                    readonlyInput="true"
                    appendTo="body"
                    hideOnDateTimeSelect="true"
                    formControlName="DateFrom"
                    monthNavigator="true"
                    yearNavigator="true"
                    yearRange="1950:2100"
                  >
                  </p-calendar>
                </div>
              </div>
              <span
                class="error-msg-colour"
                *ngIf="
                  ptwForm.submitted &&
                  PTWForm.get('DateFrom').hasError('required')
                "
                >Please Select Date</span
              >
              <span class="section-sub-title margin-left-10"> To </span>
              <div class="p-calendar calender-width">
                <p-calendar
                  hourFormat="12"
                  [minDate]="PTWForm.get('DateFrom').value"
                  [maxDate]="tillToDateForDuration"
                  [showIcon]="true"
                  dateFormat="dd/mm/yy"
                  [showTime]="false"
                  readonlyInput="true"
                  appendTo="body"
                  hideOnDateTimeSelect="true"
                  formControlName="DateTo"
                  monthNavigator="true"
                  yearNavigator="true"
                  yearRange="1950:2100"
                >
                </p-calendar>
              </div>
              <div class="clearfix calender-width"></div>
              <span
                class="error-msg-colour"
                *ngIf="
                  ptwForm.submitted &&
                  PTWForm.get('DateTo').hasError('required')
                "
                >Please Select Date</span
              >
            </div>
            <div *ngIf="isUpdate">
              <div
                *ngIf="
                  permissions.PTW_Responsible_Supervisor ||
                  permissions.PTW_Responsible_Supervisor_Unit ||
                  permissions.PTW_Admin ||
                  permissions.PTW_Admin_Unit ||
                  approvalRS
                "
              >
                <span class="section-title"> PTW Authorization</span>
                <span class="section-sub-title margin-left-10"
                  >Responsible Supervisor :</span
                >
                <div class="margin-left-20">
                  <span class="section-sub-title"
                    >Name : <label>{{ nameRS }}</label></span
                  >
                  <div class="clearfix"></div>
                  <span class="section-sub-title"
                    >Designation : <label>{{ designationRS }}</label></span
                  >
                  <div *ngIf="isPermitJob">
                    <span class="section-sub-title margin-right-20">
                      Daily Pre-Validation Allowed :
                    </span>
                    <label class="radio-inline">
                      <input
                        type="radio"
                        value="true"
                        name="isDailyValidationAllowed"
                        formControlName="isDailyValidationAllowed"
                      />Yes
                    </label>
                    <label class="radio-inline">
                      <input
                        type="radio"
                        value="false"
                        name="isDailyValidationAllowed"
                        formControlName="isDailyValidationAllowed"
                      />No
                    </label>
                    <span
                      class="error-msg-colour"
                      *ngIf="
                        ptwForm.submitted &&
                        PTWForm.get('isDailyValidationAllowed').hasError(
                          'required'
                        )
                      "
                      >Please Select Yes or No</span
                    >
                  </div>
                  <div *ngIf="isPermitJob">
                    <span class="section-sub-title margin-right-20">
                      24 Hours Validation Allowed :
                    </span>
                    <label class="radio-inline">
                      <input
                        type="radio"
                        value="true"
                        name="isHoursValidationAllowed"
                        formControlName="isHoursValidationAllowed"
                      />Yes
                    </label>
                    <label class="radio-inline">
                      <input
                        type="radio"
                        value="false"
                        name="isHoursValidationAllowed"
                        formControlName="isHoursValidationAllowed"
                      />No
                    </label>
                    <span
                      class="error-msg-colour"
                      *ngIf="
                        ptwForm.submitted &&
                        PTWForm.get('isHoursValidationAllowed').hasError(
                          'required'
                        )
                      "
                      >Please Select Yes or No</span
                    >
                  </div>
                  <div>
                    <span class="section-sub-title">
                      Permit Approved For Date :</span
                    >
                    <div class="clearfix"></div>
                    <span class="section-sub-title"> From </span>
                    <div class="p-calendar calender-width">
                      <p-calendar
                        hourFormat="12"
                        [minDate]="fromDateOfPermit"
                        (onSelect)="onRSFromDateChange()"
                        [showIcon]="true"
                        dateFormat="dd/mm/yy"
                        [showTime]="true"
                        readonlyInput="true"
                        appendTo="body"
                        hideOnDateTimeSelect="true"
                        formControlName="dateFromRS"
                        monthNavigator="true"
                        yearNavigator="true"
                        yearRange="1950:2100"
                      >
                      </p-calendar>
                    </div>
                    <span
                      class="error-msg-colour"
                      *ngIf="
                        ptwForm.submitted &&
                        PTWForm.get('dateFromRS').hasError('required')
                      "
                      >Please Select Date</span
                    >
                    <span class="section-sub-title margin-left-10"> To </span>
                    <div class="p-calendar calender-width">
                      <p-calendar
                        hourFormat="12"
                        [minDate]="PTWForm.get('dateFromRS').value"
                        [maxDate]="tillToDateForRS"
                        [showIcon]="true"
                        dateFormat="dd/mm/yy"
                        [showTime]="true"
                        readonlyInput="true"
                        appendTo="body"
                        hideOnDateTimeSelect="true"
                        formControlName="dateToRS"
                        monthNavigator="true"
                        yearNavigator="true"
                        yearRange="1950:2100"
                      >
                      </p-calendar>
                    </div>
                    <span
                      class="error-msg-colour"
                      *ngIf="
                        ptwForm.submitted &&
                        PTWForm.get('DateTo').hasError('required')
                      "
                      >Please Select Date</span
                    >
                  </div>
                  <div>
                    <input
                      type="button"
                      class="btn btn-primary button-approve"
                      pTooltip="{{ tooltipMsg }}"
                      tooltipPosition="top"
                      formControlName="btnRSApprove"
                      (click)="
                        saveApprovals(ApprovalType.ResponsibleSupervisor, true)
                      "
                      value="Approve"
                    />
                    <input
                      type="button"
                      class="btn btn-primary button-reject"
                      formControlName="btnRSReject"
                      (click)="
                        saveApprovals(ApprovalType.ResponsibleSupervisor, false)
                      "
                      value="Reject"
                    />
                    <span>
                      <textarea
                        placeholder="Remarks"
                        formControlName="remarksRS"
                        [maxLength]="1000"
                        class="margin-left-10 align-textarea"
                      >
                      </textarea>
                    </span>
                    <span *ngIf="isCertificateApproved" class="error-msg-colour"
                      >Please Approve All Certificates and Update Permit
                    </span>
                  </div>
                </div>
              </div>
              <div
                class="margin-left-10"
                *ngIf="
                  ((permissions.PTW_Responsible_Supervisor ||
                    permissions.PTW_Responsible_Supervisor_Unit ||
                    permissions.PTW_Admin ||
                    permissions.PTW_Admin_Unit) &&
                    showblockExtension) ||
                  approvalExtension
                "
              >
                <span class="section-sub-title">Extension Authorization :</span>
                <div class="margin-left-10">
                  <span class="section-sub-title"
                    >Name : <label>{{ nameExtension }}</label></span
                  >
                  <div class="clearfix"></div>
                  <span class="section-sub-title"
                    >Designation :
                    <label>{{ designationExtension }}</label></span
                  >
                  <div>
                    <span class="section-sub-title">
                      Extension Valid Until :
                      <div class="p-calendar">
                        <p-calendar
                          hourFormat="12"
                          [minDate]="PTWForm.get('dateToRS').value"
                          [maxDate]="maxDateForExtension"
                          [maxDate]="maxDateForExtension"
                          [showIcon]="true"
                          dateFormat="dd/mm/yy"
                          [showTime]="true"
                          readonlyInput="true"
                          appendTo="body"
                          hideOnDateTimeSelect="true"
                          monthNavigator="true"
                          yearNavigator="true"
                          yearRange="1950:2100"
                          formControlName="extensionValidTo"
                        >
                        </p-calendar>
                      </div>
                      <span
                        class="error-msg-colour"
                        *ngIf="
                          ptwForm.submitted &&
                          PTWForm.get('dateFromRS').hasError('required')
                        "
                        >Please Select Date</span
                      >
                    </span>
                  </div>
                  <div>
                    <input
                      type="button"
                      class="btn btn-primary button-approve"
                      formControlName="btnExtensionApprove"
                      (click)="saveApprovals(ApprovalType.Extension, true)"
                      value="Approve"
                    />
                    <input
                      type="button"
                      class="btn btn-primary button-reject"
                      formControlName="btnExtensionReject"
                      (click)="saveApprovals(ApprovalType.Extension, false)"
                      value="Reject"
                    />
                    <textarea
                      placeholder="Remarks"
                      formControlName="remarksExtension"
                      [maxLength]="1000"
                      class="margin-left-10 align-textarea"
                    ></textarea>
                  </div>
                </div>
              </div>

              <div
                class="margin-left-10"
                *ngIf="
                  ((permissions.PTW_Production_Supervisor ||
                    permissions.PTW_Production_Supervisor_Unit ||
                    permissions.PTW_Admin ||
                    permissions.PTW_Admin_Unit) &&
                    showblockPS) ||
                  approvalPS
                "
              >
                <span class="section-sub-title">Production Supervisor :</span>
                <div class="margin-left-10">
                  <span class="section-sub-title"
                    >Name : <label>{{ namePS }}</label></span
                  >
                  <div class="clearfix"></div>
                  <span class="section-sub-title"
                    >Designation : <label>{{ designationPS }}</label></span
                  >
                  <div>
                    <input
                      type="button"
                      class="btn btn-primary button-approve"
                      formControlName="btnPSApprove"
                      (click)="
                        saveApprovals(ApprovalType.ProductionSupervisor, true)
                      "
                      value="Approve"
                    />
                    <input
                      type="button"
                      class="btn btn-primary button-reject"
                      formControlName="btnPSReject"
                      (click)="
                        saveApprovals(ApprovalType.ProductionSupervisor, false)
                      "
                      value="Reject"
                    />
                    <textarea
                      placeholder="Remarks"
                      formControlName="remarksPS"
                      [maxLength]="1000"
                      class="margin-left-10 align-textarea"
                    ></textarea>
                  </div>
                </div>
              </div>
              <ng-container
                *ngIf="
                  ((permissions.PTW_Responsible_Supervisor ||
                    permissions.PTW_Responsible_Supervisor_Unit ||
                    permissions.PTW_Admin || permissions.PTW_Admin_Unit) &&
                    isUpdate &&
                    isPermitJob) ||
                  OAFRecords.length
                "
              >
                <div class="margin-left-10">
                  <span class="section-title">Other Affected Custodian</span>
                  <ara-ptw-all-tables-records
                    [RecordType]="AllTableRecordType.OtherAffectedCustodian"
                    (onTableRecordUpdate)="
                      onTableRecordsUpdate(
                        $event,
                        AllTableRecordType.OtherAffectedCustodian
                      )
                    "
                    [PermitId]="permitId"
                    [Permissions]="permissions"
                    [LastValueOfRecord]="allTablesLastRecordId"
                    [inputRecords]="OAFRecords"
                    [permitApplicant]="SelectedUserId"
                    [addRecords]="
                      ((permissions.PTW_Responsible_Supervisor ||
                        permissions.PTW_Responsible_Supervisor_Unit) &&
                        !disablePTW) ||
                      permissions.PTW_Admin ||
                      permissions.PTW_Admin_Unit
                    "
                  >
                  </ara-ptw-all-tables-records>
                  <div
                    *ngIf="
                      ((permissions.PTW_Responsible_Supervisor ||
                        permissions.PTW_Responsible_Supervisor_Unit ||
                        isOACUser(allTablesRecords)) &&
                        !disablePTW) ||
                      permissions.PTW_Admin ||
                      permissions.PTW_Admin_Unit
                    "
                  >
                    <input
                      type="button"
                      class="btn btn-primary button-update-records"
                      formControlName="btnUpdateOACRecord"
                      (click)="uploadAllTablesRecords()"
                      value="Update Records"
                    />
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="section-wrapper no-margin">
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div class="section-wrapper no-margin">
                  <span class="section-title">Certificates </span>
                  <div
                    class="table-responsive margin-bottom-20 add-action-table"
                  >
                    <table
                      class="certificate-table table table-bordered table-striped table-condensed tableheader table-red"
                    >
                      <tr class="margin-left-10">
                        <th width="100px">Is Required</th>
                        <th width="100px">Certificate Name</th>
                        <th width="150px" style="padding-left: 10px">
                          Certificate Files
                        </th>
                        <th width="300" style="padding-left: 10px">
                          Templates
                        </th>
                        <th width="350" *ngIf="isUpdate">Approvals</th>
                      </tr>
                      <tr
                        *ngFor="let certificate of Certificates; let i = index"
                      >
                        <td>
                          <input
                            type="checkbox"
                            [checked]="certificate.IsRequired"
                            [disabled]="certificate.IsDisabled"
                            [name]="'required' + i"
                            (change)="certiticateRequiredChanges($event, i)"
                          />
                        </td>
                        <td>
                          {{ certificate.CertificateName
                          }}<span
                            *ngIf="certificate.IsRequired"
                            class="mandatory"
                            >*</span
                          >
                        </td>
                        <td>
                          <ara-file-upload
                            [disabled]="!certificate.IsRequired"
                            (change)="certificate.UploadRequired = false"
                            [mode]="'basic'"
                            [inputFiles]="certificate.Files"
                            (onInputFilesUpdatedData)="
                              onInputFilesUpdated($event, 'Certificate', i)
                            "
                          ></ara-file-upload>
                          <ara-files-previewer
                            *ngIf="isUpdate"
                            [files]="certificate.Files"
                          ></ara-files-previewer>
                          <span
                            class="error-msg-colour"
                            *ngIf="certificate.UploadRequired"
                            >Please Upload File
                          </span>
                        </td>

                        <td>
                          <button
                            type="button"
                            (click)="
                              downloadTemplate(certificate.TemplateFiles)
                            "
                            [disabled]="!certificate.IsRequired"
                            class="active-btn orange-btn button-download-template button-pdf"
                          >
                            Download Template
                          </button>
                          <div *ngIf="certificate.IsRequired">
                            <span
                              *ngIf="certificate.TemplateFiles"
                              class="info-msg-colour"
                            >
                              Current version of template is
                              <strong>{{ certificate.CurrentVersion }}</strong>
                            </span>
                            <span
                              *ngIf="!certificate.TemplateFiles"
                              class="error-msg-colour"
                            >
                              Template file is not available. Please contact
                              admin, if you require latest template.
                            </span>
                          </div>
                        </td>
                        <td *ngIf="isUpdate">
                          <label>
                            <input
                              type="radio"
                              [disabled]="!certificate.IsRequired"
                              [name]="'approval' + i"
                              (change)="certificate.IsApproved = true"
                              [checked]="certificate.IsApproved"
                            />
                            Accept</label
                          >
                          <label>
                            <input
                              type="radio"
                              [disabled]="!certificate.IsRequired"
                              [name]="'approval' + i"
                              (change)="certificate.IsApproved = false"
                              [checked]="!certificate.IsApproved"
                            />
                            Reject</label
                          >
                          <input
                            placeholder="Remarks"
                            [disabled]="!certificate.IsRequired"
                            [name]="'remark' + i"
                            (change)="
                              onRemarkChange(
                                $event,
                                certificate.CertificateType
                              )
                            "
                            [value]="
                              certificate.Remarks ? certificate.Remarks : ''
                            "
                            [name]="'remark' + i"
                            class="margin-left-10"
                            type="text"
                          />
                          <span
                            *ngIf="certificate.RemarkRequired"
                            class="error-msg-colour"
                            >Please Add Remarks
                          </span>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            *ngIf="
              isUpdate &&
              permitStatus != PermitStatus.PendingForAuthorization &&
                permitStatus != PermitStatus.RejectedByRS &&
                permitStatus != PermitStatus.AuthorizedByRS &&
                permitStatus != PermitStatus.RejectedByPS
            "
          >
            <div
              *ngIf="
                ((isOncomingUserAndApplicant ||
                  permissions.PTW_Admin ||
                  permissions.PTW_Admin_Unit) &&
                  isPermitJob) ||
                TRICTableRecords.length
              "
              class="col-lg-12 col-md-12 col-sm-12 col-xs-12"
            >
              <div class="section-wrapper no-margin">
                <span class="section-title">TRIC Talk</span>
                <div class="margin-left-10">
                  <ara-ptw-all-tables-records
                    [RecordType]="AllTableRecordType.TRICTalk"
                    (onTableRecordUpdate)="
                      onTableRecordsUpdate($event, AllTableRecordType.TRICTalk)
                    "
                    [PermitId]="permitId"
                    [LastValueOfRecord]="TRICTableLastRecordId"
                    [TRICinputRecords]="TRICTableRecords"
                    [Permissions]="permissions"
                    [LastValueofAttendeeRecord]="AttendeeTableLastRecordId"
                    [addRecords]="IsAddRecordsForTRICTalk()"
                  >
                  </ara-ptw-all-tables-records>
                  <div *ngIf="IsAddRecordsForTRICTalk()">
                    <input
                      type="button"
                      class="btn btn-primary button-update-records"
                      formControlName="btnUpdateValidationRecord"
                      (click)="uploadAllTablesRecords()"
                      value="Update Records"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <div
                *ngIf="
                  ((permissions.PTW_Area_Authority ||
                    permissions.PTW_Area_Authority_Unit ||
                    permissions.PTW_Admin ||
                    permissions.PTW_Admin_Unit) &&
                    isPermitJob &&
                    showSafetyTable) ||
                  SafetyRecords.length
                "
                class="col-lg-6 col-md-6 col-sm-6 col-xs-6"
              >
                <div class="section-wrapper no-margin">
                  <span class="section-title">Safety Coordination</span>
                  <div class="margin-left-10">
                    <ara-ptw-all-tables-records
                      [RecordType]="AllTableRecordType.SafetyCoordination"
                      (onTableRecordUpdate)="
                        onTableRecordsUpdate(
                          $event,
                          AllTableRecordType.SafetyCoordination
                        )
                      "
                      [PermitId]="permitId"
                      [Permissions]="permissions"
                      [LastValueOfRecord]="allTablesLastRecordId"
                      [inputRecords]="SafetyRecords"
                      [addRecords]="
                        ((permissions.PTW_Area_Authority ||
                          permissions.PTW_Area_Authority_Unit) &&
                          !disablePTW) ||
                        permissions.PTW_Admin ||
                        permissions.PTW_Admin_Unit
                      "
                    >
                    </ara-ptw-all-tables-records>
                    <div
                      *ngIf="
                        ((permissions.PTW_Area_Authority ||
                          permissions.PTW_Area_Authority_Unit) &&
                          !disablePTW) ||
                        permissions.PTW_Admin ||
                        permissions.PTW_Admin_Unit
                      "
                    >
                      <input
                        type="button"
                        class="btn btn-primary button-update-records"
                        formControlName="btnUpdateSafetyCoordinatorRecord"
                        (click)="uploadAllTablesRecords()"
                        value="Update Records"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div
                *ngIf="
                  ((permissions.PTW_Area_Authority ||
                    permissions.PTW_Area_Authority_Unit ||
                    permissions.PTW_Admin ||
                    permissions.PTW_Admin_Unit) &&
                    isPermitJob &&
                    showSafetyTable) ||
                  ValidationRecords.length
                "
                class="col-lg-6 col-md-6 col-sm-6 col-xs-6"
              >
                <div class="section-wrapper no-margin">
                  <span class="section-title">Validation</span>
                  <div class="margin-left-10">
                    <ara-ptw-all-tables-records
                      [RecordType]="AllTableRecordType.Validation"
                      (onTableRecordUpdate)="
                        onTableRecordsUpdate(
                          $event,
                          AllTableRecordType.Validation
                        )
                      "
                      [PermitId]="permitId"
                      [Permissions]="permissions"
                      [LastValueOfRecord]="allTablesLastRecordId"
                      [inputRecords]="ValidationRecords"
                      [addRecords]="
                        ((permissions.PTW_Area_Authority ||
                          permissions.PTW_Area_Authority_Unit) &&
                          !disablePTW) ||
                        permissions.PTW_Admin ||
                        permissions.PTW_Admin_Unit
                      "
                    >
                    </ara-ptw-all-tables-records>
                    <div
                      *ngIf="
                        ((permissions.PTW_Area_Authority ||
                          permissions.PTW_Area_Authority_Unit) &&
                          !disablePTW) ||
                        permissions.PTW_Admin ||
                        permissions.PTW_Admin_Unit
                      "
                    >
                      <input
                        type="button"
                        class="btn btn-primary button-update-records"
                        formControlName="btnUpdateValidationRecord"
                        (click)="uploadAllTablesRecords()"
                        value="Update Records"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <div
                *ngIf="
                  ((isOncomingUserAndApplicant ||
                    permissions.PTW_Admin ||
                    permissions.PTW_Admin_Unit) &&
                    showOtherTables) ||
                  AcceptanceRecords.length
                "
                class="col-lg-6 col-md-6 col-sm-6 col-xs-6"
              >
                <div class="section-wrapper no-margin">
                  <span class="section-title">Acceptance</span>
                  <div class="margin-left-10">
                    <ara-ptw-all-tables-records
                      [RecordType]="AllTableRecordType.Acceptance"
                      (onTableRecordUpdate)="
                        onTableRecordsUpdate(
                          $event,
                          AllTableRecordType.Acceptance
                        )
                      "
                      [PermitId]="permitId"
                      [Permissions]="permissions"
                      [LastValueOfRecord]="allTablesLastRecordId"
                      [inputRecords]="AcceptanceRecords"
                      [addRecords]="
                        (isOncomingUserAndApplicant && !disablePTW) ||
                        permissions.PTW_Admin ||
                        permissions.PTW_Admin_Unit
                      "
                    >
                    </ara-ptw-all-tables-records>
                    <div>
                      <input
                        *ngIf="
                          (isOncomingUserAndApplicant && !disablePTW) ||
                          permissions.PTW_Admin ||
                          permissions.PTW_Admin_Unit
                        "
                        type="button"
                        class="btn btn-primary button-update-records"
                        formControlName="btnUpdateAcceptanceRecord"
                        (click)="uploadAllTablesRecords()"
                        value="Update Records"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div
                *ngIf="
                  ((isOncomingUserAndApplicant ||
                    permissions.PTW_Admin ||
                    permissions.PTW_Admin_Unit) &&
                    showOtherTables) ||
                  SuspensionRecords.length
                "
                class="col-lg-6 col-md-6 col-sm-6 col-xs-6"
              >
                <div class="section-wrapper no-margin">
                  <span class="section-title">Suspension</span>
                  <div class="margin-left-10">
                    <ara-ptw-all-tables-records
                      [RecordType]="AllTableRecordType.Suspension"
                      (onTableRecordUpdate)="
                        onTableRecordsUpdate(
                          $event,
                          AllTableRecordType.Suspension
                        )
                      "
                      [PermitId]="permitId"
                      [Permissions]="permissions"
                      [LastValueOfRecord]="allTablesLastRecordId"
                      [inputRecords]="SuspensionRecords"
                      [addRecords]="
                        (isOncomingUserAndApplicant && !disablePTW) ||
                        permissions.PTW_Admin ||
                        permissions.PTW_Admin_Unit
                      "
                    >
                    </ara-ptw-all-tables-records>
                    <div
                      *ngIf="
                        (isOncomingUserAndApplicant && !disablePTW) ||
                        permissions.PTW_Admin ||
                        permissions.PTW_Admin_Unit
                      "
                    >
                      <input
                        type="button"
                        class="btn btn-primary button-update-records"
                        formControlName="btnUpdateSuspensionRecord"
                        (click)="uploadAllTablesRecords()"
                        value="Update Records"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div
              *ngIf="
                (showOtherTables &&
                  (isOncomingUserAndApplicant ||
                    permissions.PTW_Admin ||
                    permissions.PTW_Admin_Unit)) ||
                applyCancelation
              "
              class="col-lg-6 col-md-6 col-sm-6 col-xs-6"
            >
              <div class="section-wrapper no-margin">
                <span class="section-title">Apply for Cancellation</span>
                <div class="margin-left-10">
                  <input
                    type="button"
                    class="btn btn-primary button-work-complete"
                    formControlName="btnApplyCancellationApprove"
                    (click)="
                      saveApprovals(ApprovalType.CancellationApplied, true)
                    "
                    value="Approve"
                  />
                  <input
                    type="button"
                    class="btn btn-primary margin-left-10 button-work-not-complete"
                    formControlName="btnApplyCancellationReject"
                    (click)="
                      saveApprovals(ApprovalType.CancellationApplied, false)
                    "
                    value="Reject"
                  />
                </div>
              </div>
            </div>
            <div
              *ngIf="
                (showApproveCancelation &&
                  (permissions.PTW_Area_Authority ||
                    permissions.PTW_Area_Authority_Unit ||
                    permissions.PTW_Admin ||
                    permissions.PTW_Admin_Unit)) ||
                approvalCancelation
              "
              class="col-lg-6 col-md-6 col-sm-6 col-xs-6"
            >
              <div class="section-wrapper no-margin">
                <span class="section-title"
                  >Permit Cancellation by Permit Holder</span
                >
                <div class="margin-left-10">
                  <span class="section-sub-title"
                    >Name : <label>{{ nameCanclePermitHolder }}</label></span
                  >
                  <div class="clearfix"></div>
                  <span class="section-sub-title"
                    >Designation :
                    <label>{{ designationCanclePermitHolder }}</label></span
                  >
                  <div class="clearfix"></div>
                  <span class="section-sub-title"
                    >Date :
                    <label>{{
                      dateCanclePermitHolder
                        | dateTimeFormat : "MMM D, YYYY hh:mm:ss"
                    }}</label>
                  </span>
                  <div class="clearfix"></div>
                  <span class="section-sub-title"
                    >Permit Cancellation Status :
                    <label>{{ statusApplyCanclePermit }}</label></span
                  >
                </div>
                <span class="section-title"
                  >Permit Cancellation by Area Authority</span
                >
                <div class="margin-left-10">
                  <span class="section-sub-title"
                    >Name : <label>{{ nameCanclePermitAA }}</label></span
                  >
                  <div class="clearfix"></div>
                  <span class="section-sub-title"
                    >Designation :
                    <label>{{ designationCanclePermitAA }}</label></span
                  >
                  <div>
                    <span class="section-sub-title margin-right-20">
                      Worksite and Equipment affected left in safe condition ?
                    </span>
                    <label class="radio-inline">
                      <input
                        type="radio"
                        value="true"
                        name="isEquipmentSafeCondition"
                        formControlName="isEquipmentSafeCondition"
                      />Yes
                    </label>
                    <label class="radio-inline">
                      <input
                        type="radio"
                        value="false"
                        name="isEquipmentSafeCondition"
                        formControlName="isEquipmentSafeCondition"
                      />No
                    </label>
                    <span
                      class="error-msg-colour"
                      *ngIf="
                        ptwForm.submitted &&
                        PTWForm.get('isEquipmentSafeCondition').hasError(
                          'required'
                        )
                      "
                      >Please Select Yes or No</span
                    >
                  </div>
                  <div>
                    <span class="section-sub-title margin-right-20">
                      Worksite checked , Clear and Safe (Process Facility only)
                      ?
                    </span>
                    <label class="radio-inline">
                      <input
                        type="radio"
                        value="true"
                        name="isWorksiteSafeAndClear"
                        formControlName="isWorksiteSafeAndClear"
                      />Yes
                    </label>
                    <label class="radio-inline">
                      <input
                        type="radio"
                        value="false"
                        name="isWorksiteSafeAndClear"
                        formControlName="isWorksiteSafeAndClear"
                      />No
                    </label>
                    <span
                      class="error-msg-colour"
                      *ngIf="
                        ptwForm.submitted &&
                        PTWForm.get('isWorksiteSafeAndClear').hasError(
                          'required'
                        )
                      "
                      >Please Select Yes or No</span
                    >
                  </div>
                  <div>
                    <span class="section-sub-title margin-right-20">
                      Reinstements/De-Isolation complete ?
                    </span>
                    <label class="radio-inline">
                      <input
                        type="radio"
                        value="true"
                        name="isReinstatementsComplete"
                        formControlName="isReinstatementsComplete"
                      />Yes
                    </label>
                    <label class="radio-inline">
                      <input
                        type="radio"
                        value="false"
                        name="isReinstatementsComplete"
                        formControlName="isReinstatementsComplete"
                      />No
                    </label>
                    <span
                      class="error-msg-colour"
                      *ngIf="
                        ptwForm.submitted &&
                        PTWForm.get('isReinstatementsComplete').hasError(
                          'required'
                        )
                      "
                      >Please Select Yes or No</span
                    >
                  </div>
                </div>
                <input
                  type="button"
                  class="btn btn-primary button-approve"
                  formControlName="btnCancellationApprove"
                  (click)="
                    saveApprovals(ApprovalType.CancellationApproval, true)
                  "
                  value="Approve"
                />
                <input
                  type="button"
                  class="btn btn-primary margin-left-10 button-reject"
                  formControlName="btnCancellationReject"
                  (click)="
                    saveApprovals(ApprovalType.CancellationApproval, false)
                  "
                  value="Reject"
                />
                <input
                  placeholder="Remarks"
                  formControlName="remarksCancellation"
                  class="margin-left-10"
                  type="text"
                />
              </div>
            </div>
          </div>

          <div class="clearfix"></div>
          <div class="breaker"></div>
          <ara-record-actions
            [SourceId]="permitId"
            ModuleName="PermitToWork"
            [ShowCancel]="
              (permissions.PTW_Admin || permissions.PTW_Admin_Unit) &&
              isUpdate &&
              permitStatus !== PermitStatus.Deleted &&
              permitStatus !== PermitStatus.Cancelled
            "
            [ShowDelete]="
              independentPermissions.SUPER_Admin &&
              isUpdate &&
              permitStatus !== PermitStatus.Deleted &&
              permitStatus !== PermitStatus.Cancelled
            "
            (output)="getOutput($event)"
          >
          </ara-record-actions>
          <footer>
            <p-footer>
              <!-- <button type="button" class="btn btn-primary primary-btn button-draft" (click)="saveAsDraft()" 
              *ngIf="(permitId === 0 || permitStatus == PermitStatus.Draft) && ((PTWForm.get('IsAgreeFrozenPlan').value && isPermitJob) || !isPermitJob)"> -->
              <button
                type="submit"
                class="btn btn-primary primary-btn button-draft"
                (click)="saveAsDraft()"
                *ngIf="
                  (permitId === 0 || permitStatus == PermitStatus.Draft) &&
                  (isPermitJob || !isPermitJob)
                "
              >
                <i class="fa fa-envelope"></i>Save As Draft
              </button>
              <button
                role="button"
                class="btn btn-warning button-reset"
                (click)="ResetForm()"
              >
                <i class="fa fa-refresh"></i>Reset
              </button>
              <button
                routerLink="/ptw/permit-overview"
                role="button"
                class="btn btn-primary primary-btn button-back button-float-left"
              >
                <i class="fa fa-reply"></i>Back To Overview
              </button>
              <button
                type="button"
                *ngIf="permitId > 0"
                (click)="ReportshowDialog()"
                class="btn btn-primary primary-btn button-report-log button-float-left"
              >
                Report Log
              </button>
              <button
                *ngIf="permitId > 0"
                role="button"
                class="btn btn-primary primary-btn button-pdf"
                (click)="downloadPDF()"
              >
                <i class="fa fa-file-pdf-o"></i>DOWNLOAD PDF
              </button>
              <!-- <button
                *ngIf="(!isUpdate && ((PTWForm.get('IsAgreeFrozenPlan').value && isPermitJob) || !isPermitJob)) && isPermitTypeDecided"
                type="submit" pButton label="SUBMIT" (click)="submitApplyPermit()"
                class="btn btn-success button-submit"><i class="fa fa-share-square"></i></button> -->
              <button
                *ngIf="!isUpdate && (isPermitJob || !isPermitJob)"
                type="submit"
                pButton
                label="SUBMIT"
                (click)="submitApplyPermit()"
                class="btn btn-success button-submit"
              >
                <i class="fa fa-share-square"></i>
              </button>
              <button
                [disabled]="
                  editEnabled === false ||
                  !isUpdateAllowed ||
                  isInactiveLocation
                "
                [title]="isInactiveLocation ? 'This location is inactive' : ''"
                *ngIf="
                  isUpdate &&
                  permitStatus !== PermitStatus.Draft &&
                  ((PTWForm.get('IsAgreeFrozenPlan').value && isPermitJob) ||
                    !isPermitJob) &&
                  ((isApplicant &&
                    (permitStatus == PermitStatus.PendingForAuthorization ||
                      permitStatus == PermitStatus.RejectedByRS ||
                      permitStatus == PermitStatus.RejectedByPS)) ||
                    permissions.PTW_Admin || permissions.PTW_Admin_Unit)
                "
                type="submit"
                (click)="updatePermit()"
                class="btn btn-success button-update"
              >
                <i class="fa fa-share-square"></i>UPDATE
              </button>
              <button
                *ngIf="
                  permitStatus === PermitStatus.Draft &&
                  ((PTWForm.get('IsAgreeFrozenPlan').value && isPermitJob) ||
                    !isPermitJob)
                "
                type="submit"
                pButton
                label="SUBMIT"
                (click)="submitApplyPermit()"
                class="btn btn-success button-submit"
              >
                <i class="fa fa-share-square"></i>
              </button>
            </p-footer>
          </footer>
        </div>
      </div>
      <div class="clearfix"></div>
    </div>
  </div>
  <div class="clearfix"></div>
</form>

<p-dialog
  [(visible)]="display"
  header="Permit Form"
  [modal]="true"
  [ngStyle]="{ height: dialogHeight }"
  [ngStyle]="{ width: dialogWidth }"
>
  <ara-permit-dialog
    (parentFunction)="parentFunction($event)"
  ></ara-permit-dialog>
</p-dialog>

<ara-alerts
  [alertType]="alertType"
  [successDetails]="successDetails"
  [errorDetails]="errorDetails"
  (okClicked)="onOkClickedForConfirmation()"
  [confirmMessage]="confirmMessage"
  (yesClicked)="onYesClickedForConfirmation()"
  (noClicked)="onNoClickedForConfirmation()"
></ara-alerts>
<div class="clearfix"></div>

<span *ngIf="ReportclosePopup">
  <p-dialog
    header="Report History"
    [(visible)]="ReportclosePopup"
    (onHide)="ReportclosePopUp()"
    [modal]="true"
  >
    <ara-report-log
      [ReportUserId]="ReportUserId"
      [ReportModule]="ReportModule"
      [ReportRecordId]="ReportRecordId"
    >
    </ara-report-log>
  </p-dialog>
</span>
